module.exports = __webpack_public_path__ + "static/media/bodiometer_dashboard.c0858d6a.mp4";